import { render, staticRenderFns } from "./OrderHelp.vue?vue&type=template&id=a723f982&scoped=true&"
import script from "./OrderHelp.vue?vue&type=script&lang=js&"
export * from "./OrderHelp.vue?vue&type=script&lang=js&"
import style0 from "../../less/order.less?vue&type=style&index=0&id=a723f982&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a723f982",
  null
  
)

export default component.exports